import { Component, Inject, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '../../services/api.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-merchant-upload-view',
  templateUrl: './merchant-upload-view.component.html',
  styleUrls: ['./merchant-upload-view.component.scss']
})
export class MerchantUploadViewDialog implements OnInit, AfterViewInit {
  loading = false;
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = [
    'transferId',
    'transactionId',
    'transferDate',
    'description',
    'otherPartyAccount',
    'debit',
    'credit',
    'balance',
    'phoneTo',
    'phoneFrom',
    'transactionType',
    'merchantName'
  ];
  totalRecords = 0;
  totalDebit = 0;
  totalCredit = 0;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    public dialogRef: MatDialogRef<MerchantUploadViewDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { employeeId: number; cycleStart: string; cycleEnd: string },
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.loadUploadData();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  loadUploadData(): void {
    this.loading = true;
    this.apiService.getMerchantUploadsPaginated(
      this.data.employeeId,
      this.data.cycleStart,
      this.data.cycleEnd,
      0,
      1000 // Load all records for client-side pagination
    ).subscribe({
      next: (response: any) => {
        this.dataSource.data = response.data || [];
        this.totalRecords = response.total || 0;
        this.calculateTotals();
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading merchant upload data:', error);
        this.loading = false;
      }
    });
  }

  calculateTotals(): void {
    this.totalDebit = this.dataSource.data.reduce((sum: number, item: any) => sum + (parseFloat(item.debit) || 0), 0);
    this.totalCredit = this.dataSource.data.reduce((sum: number, item: any) => sum + (parseFloat(item.credit) || 0), 0);
  }

  exportToExcel(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.dataSource.data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Merchant Upload Data');
    XLSX.writeFile(wb, `merchant_upload_${this.data.employeeId}_${this.data.cycleStart}_${this.data.cycleEnd}.xlsx`);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
